import { Injectable, signal } from '@angular/core';
import { environment as env } from '../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from './storage.service';
import { HttpService } from './http.service';
import { API_AUTH_LOGIN, API_AUTH_LOGOUT, HOME_ROUTE, WEBSITE_API_URL } from '../constants/constants';
import { UserLogged } from '@shared/models/user';
import { EntityTypes } from 'app/core/models/general-entity.types';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user = signal<UserLogged | null>(null);

  constructor(
    private router: Router,
    private http: HttpClient,
    private storageService: StorageService,
    private httpService: HttpService
  ) {
    const user = this.storageService.getFromLocalOrSessionStorage('user');
    this.setUser(user);
  }

  login(email: string, password: string): Observable<object> {
    const url = `${env.baseUrl}${WEBSITE_API_URL}${API_AUTH_LOGIN}`
    return this.httpService.post(url, { email, password });
  }

  logout(): void {
    this.storageService.clearStorage();
    this.setUser(null);
    this.router.navigate([HOME_ROUTE]);
  }

  forgotPassword(email: string): Observable<object> {
    const url = `${env.baseUrl}${WEBSITE_API_URL}forgot-password`;
    return this.httpService.post(url, { email });
  }

  getUserProfile(): Observable<any> {
    const url = `${env.baseUrl}${WEBSITE_API_URL}profile`;
    return this.http.get<any>(url);
  }

  updateProfile(request: any): Observable<any> {
    const url = `${env.baseUrl}${WEBSITE_API_URL}profile`;
    return this.http.post<any>(url, request);
  }

  changePassword(request: any): Observable<object> {
    const url = `${env.baseUrl}${WEBSITE_API_URL}update-password`;
    return this.httpService.put(url, request);
  }

  resetPassword(request: any): Observable<object> {
    const url = `${env.baseUrl}${WEBSITE_API_URL}reset-password`;
    return this.httpService.post(url, request);
  }

  logoutApi(): Observable<object> {
    const url = `${env.baseUrl}${WEBSITE_API_URL}${API_AUTH_LOGOUT}`;
    return this.httpService.post(url, {});
  }

  setUser(user: any | null) {
    this.user.set(user);
  }

  getRole(): EntityTypes | null{
    if (!this.user()) {
      console.error('role undefined')
      return null;
    }
    return this.user()?.user?.role as EntityTypes ?? null;
  }

  getFullUserName() {
    if (!this.user()) {
      return ''
    }
    return `${this.user()?.user?.name} ${this.user()?.user?.surname}`;
  }

  isLoggedIn() {
    return this.user() !== null;
  }
}
